<app-card [isHeader]=true [title]="'search_filter'|translate">

        <form (ngSubmit)="submit()" [formGroup]="form">
            <div class="cp5" fxLayout="row wrap" fxLayoutAlign="start center">

                <div fxFlex="25" fxFlex.lt-md="100">
                    <app-text-field [control]="getFormControl('shopNo')" [label]="labels.shopNo | translate">
                    </app-text-field>
                </div>
               

                   

                    <div fxFlex="50" fxFlex.lt-md="100" *ngIf="getlang()==='fr'">
    
  
                        <app-combo-commande  fxFlex.lt-md="100"  [control]="getFormControl('pbkStrFr')"  [controlFils]="getFormControl('bizKindStrFr')" 
                        [label]="labels.pbkStrFr | translate"  [code]="commmCode.categorieActivite"></app-combo-commande>
                    </div>
                    <div   fxFlex="50" fxFlex.lt-md="100" *ngIf="getlang()==='ar'">
                        <app-combo-commande  [control]="getFormControl('pbkStrAr')"  [controlFils]="getFormControl('bizKindStrAr')" 
                        [label]="labels.pbkStrFr | translate"  [code]="commmCode.categorieActivite"></app-combo-commande>
                      </div>
                      


                <div fxFlex="25" fxFlex.lt-md="100">
                    <app-combo-acheteur [control]="getFormControl('instNm')" [label]="labels.instNm | translate">
                    </app-combo-acheteur>
                </div>
            </div>

     

              

                <div 
                fxflex="100" class="cp5" fxLayout="row wrap" fxLayoutAlign="start center"
                *ngIf="panelOpenState">
                <div fxFlex="25" fxFlex.lt-md="100">
                    <app-text-field [control]="getFormControl('shopNmFr')" [label]="labels.shopNmFr | translate">
                    </app-text-field>
                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                    <app-select-date [control]="getFormControl('publicDt')" label="aprés cette date publication">
                    </app-select-date>

                </div>
                <div fxFlex="25" fxFlex.lt-md="100">
                    <app-select-date [control]="getFormControl('publicDt_end')" label="avant cette date publication">
                    </app-select-date>

                </div>
                <div fxFlex="25"  fxFlex.lt-md="100">
                    <app-select-date [control]="getFormControl('spRecvEndDt')"
                        label="'Dernier Délai Réception Offres (Aprés)'"></app-select-date>

                </div>
                <div fxFlex="25"  fxFlex.lt-md="100">
                    <app-select-date [control]="getFormControl('spRecvEndDtStr_end')"
                        label="'Dernier Délai Réception Offres (Avant)"></app-select-date>

                </div>
            
            </div>
            
            <div  fxLayoutAlign="end end">
            <div>
                <button class="filter-btn" style="background-color: #3498db;" color="primary" mat-flat-button type="submit">
                    <mat-icon>{{ icons.search }}</mat-icon>
                    <span translate>search</span>
                </button>
            </div>
            <div style="margin-left: 1%;margin-right: 1%;">
                <button class="filter-btn" color="primary" mat-flat-button type="submit" (click)="reset()">
                    <mat-icon>{{ icons.reset }}</mat-icon>
                    <span translate>reset</span>
                </button>
            </div> 

            <div>
                <a  class="filter-btn"
                style="background-color: #FFFFFF;
                "
                mat-flat-button
                 *ngIf="panelOpenState==true" (click)="panelOpenState=!panelOpenState"  ><mat-icon>remove_circle_outline</mat-icon></a>
                <a  
                class="filter-btn"
                style="background-color: #FFFFFF;
                "
                mat-flat-button
                *ngIf="panelOpenState==false" (click)="panelOpenState=!panelOpenState"  ><mat-icon>add_circle_outline</mat-icon></a>
              </div>
        </div>




        </form>
</app-card>